var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import Modal, { ModalContent, ModalHeader, ModalBody, ModalFooter, ModalCloseButton, } from "../modal";
import Flex from "../templates/flex";
import { Button } from "../button";
var actionButtonStyles = {
    default: {
        confirm: { flavour: "defalut" },
        decline: { flavour: "hollow", danger: true },
    },
    reverse: {
        decline: { flavour: "default" },
        confirm: { flavour: "hollow", danger: true },
    },
};
var flexProperties = {
    default: {
        justifyContent: "end",
    },
    reverse: {
        rowReverse: true,
        justifyContent: "start",
    },
};
var ConfirmationDialog = function (_a) {
    var title = _a.title, message = _a.message, confirmLabel = _a.confirmLabel, declineLabel = _a.declineLabel, handleConfirm = _a.handleConfirm, handleDecline = _a.handleDecline, _b = _a.actionButtonDirection, actionButtonDirection = _b === void 0 ? "default" : _b;
    var _c = actionButtonStyles[actionButtonDirection], confirmStyles = _c.confirm, declineStyles = _c.decline;
    var flexProps = flexProperties[actionButtonDirection];
    return (React.createElement(Modal, null,
        React.createElement(ModalContent, null,
            React.createElement(ModalHeader, null,
                title,
                React.createElement(ModalCloseButton, { onClose: handleDecline })),
            React.createElement(ModalBody, null, message),
            React.createElement(ModalFooter, { hasBorder: false },
                React.createElement(Flex, __assign({ gap: 4, width: "100%" }, flexProps),
                    React.createElement(Button, __assign({ "data-testid": "confirmation-dialog-confirm" }, confirmStyles, { label: confirmLabel, onClick: handleConfirm })),
                    React.createElement(Button, __assign({ "data-testid": "confirmation-dialog-decline" }, declineStyles, { label: declineLabel, onClick: handleDecline })))))));
};
export default ConfirmationDialog;
